module.exports = __webpack_public_path__ + "img/heart-icon.88a8f4ba.svg";